module.exports = __webpack_public_path__ + "src/img/galerie/innenrenovierung/Innentreppe-Vorher.jpg";